import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Typography, Card, CardContent, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import '../../../node_modules/centracare-scheduling/registry/css/index.css';
import { faVial } from '@fortawesome/pro-solid-svg-icons';
import { faRibbon } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const useStyles = makeStyles(
  () => ({
    header: {
      fontFamily: 'Montserrat',
      margin: '20px 0.5rem 6px 0.5rem',
      fontSize: '1.5rem',
      fontWeight: '500',
      textAlign: 'left',
      color: '#192129',
    },
    mainContentContainer: {
      fontFamily: 'Montserrat',
      margin: '0 auto',
      maxWidth: '1232px',
      padding: '0 16px',
    },
    duelContainer: {
      fontFamily: 'Montserrat',
      display: 'flex',
      columnGap: '24px',
      justifyContent: 'center',
      margin: '22px 0px',
      '@media (max-width: 480px)': {
        flexDirection: 'column',
        rowGap: '24px',
      },
    },
    cardStyles: {
      fontFamily: 'Montserrat',
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',
      width: '45%',
      '@media (max-width: 480px)': {
        width: '100%',
      },
    },
    content: {
      padding: '16px !important',
      fontFamily: 'Montserrat',
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',
    },
    iconStyle: {
      fontFamily: 'Montserrat',
      color: '#006298',
      margin: '0 auto',
      fontSize: '30px',
    },
    pStyle: {
      fontFamily: 'Montserrat',
      textAlign: 'center',
      fontWeight: '500',
      fontSize: '1.5rem',
      color: '#192129',
    },
    button: {
      fontFamily: 'Montserrat',
      backgroundColor: '#006298',
      color: 'white',
      fontSize: '14px',
      fontWeight: '600',
      textTransform: 'none',
      letterSpacing: '0.11px',
      lineHeight: '20px',
      '&:hover': {
        backgroundColor: '#118AC7',
      },
    },
    subheader: {
      fontFamily: 'Montserrat',
      fontSize: '16px',
      color: '#192129',
    },
  }),
  {
    name: 'hwui-UrgentCareVisitSelect',
  }
);

const LabMammoDirectScheduling = ({ history }) => {
  const classes = useStyles();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const projectEnvironmnet = urlParams.get('env');
  const projectMode = urlParams.get('mode');
  const urldata = {};
  if (projectEnvironmnet) {
    urldata.env = projectEnvironmnet;
  }
  if (projectMode && projectMode === 'auth') {
    urldata.mode = 'auth';
  }
  const addParams = new URLSearchParams(urldata).toString();

  return (
    <div className={classes.mainContentContainer}>
      <Typography variant="h1" className={classes.header}>
        Which type of appointment would you like to schedule?
      </Typography>
      <p className={classes.subheader}>
        Select your visit type so we can direct you appropriately:
      </p>
      <div className={classes.duelContainer}>
        <Card className={classes.cardStyles} variant="outlined">
          <CardContent className={classes.content}>
            <FontAwesomeIcon icon={faVial} className={classes.iconStyle} />
            <p className={classes.pStyle}>Lab Test</p>
            <br />
            <Button
              variant="contained"
              onClick={() =>
                history.push(
                  `/find-care/LabRegionSelectDirectScheduling?${addParams}`
                )
              }
              className={classes.button}
            >
              Schedule Appointment
            </Button>
          </CardContent>
        </Card>
        <Card className={classes.cardStyles} variant="outlined">
          <CardContent className={classes.content}>
            <FontAwesomeIcon icon={faRibbon} className={classes.iconStyle} />
            <p className={classes.pStyle}>Mammogram</p>
            <br />
            <Button
              variant="contained"
              onClick={() =>
                history.push(
                  `/find-care/MammoRegionSelectDirectScheduling?${addParams}`
                )
              }
              className={classes.button}
            >
              Schedule Appointment
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

LabMammoDirectScheduling.propTypes = {
  history: PropTypes.object,
};

export default withRouter(LabMammoDirectScheduling);
